module.exports = __webpack_public_path__ + "media/08_percussion-sound.e444a2c3.mp3";